// extracted by mini-css-extract-plugin
export var quillEditor = "_q0-1";
export var variable = "_q0-0";